import firebase from "firebase/app";
import "firebase/app";

// Initialize Firebase app
// live

firebase.initializeApp({
  apiKey: "AIzaSyDsgWedFTzMLFhRZ5z7DEF3YCsQWRDqRU8",
  authDomain: "dailystayfit.com",
  databaseURL: "https://dailystayfit-website.firebaseio.com",
  projectId: "dailystayfit-website",
  storageBucket: "dailystayfit-website.appspot.com",
  messagingSenderId: "747381439543",
  appId: "1:747381439543:web:c81d08168691e49a2013b2",
  measurementId: "G-V301EPJZ0W"
});
